import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-modal';

import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout, reset } from "../../../features/auth/authSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { setBankFetchUpdate } from '../../../features/bankFetchUpdate/bankFetchUpdateSlice';
import { getBankFromCompany } from "../../Invoices/InvoicesSingle/services/invoiceSingle.js";
import Currencies from "../../../constants/currencies";
import { ThreeDots } from "react-loader-spinner";
import "./newBank.css";
Modal.setAppElement('#root');

const NewBank = (props) => {

  const dispatch = useDispatch();
  const [currency, setCurrency] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [req, setReq] = useState([]);
  const [type, setType] = useState(null);
  const [fields, setFields] = useState([])
  const [errors, setErrors] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [accountHolderName, setAccountHolderName] = useState("");
  const [wxCom, setWxCom] = useState(null);
  const [wiseCompany, setWiseCompany] = useState([]);
  const [userWiseProfile, setUserWiseProfile] = useState(null);
  const navigate = useNavigate();
  const token = useSelector(
    (state) => state.auth.token
  )
  const wxCompany = props?.userView?.user_wx_comapny?.wx_company;
  useEffect(() => {
    async function getUserWiseProfile() {
      await axios
        .post(
          "/api/wise/user-wise-profile",
          { userId: `${props?.userView?._id}`, },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setWiseCompany(response?.data?.id);
        });
    }
    getUserWiseProfile();

    async function getUserWxCompany() {
      await axios
        .get("/api/get-wx-comapies",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setUserWiseProfile(response.data.filter(
            (compny) =>
              compny.wx_company !== "Any"
          ));
        });
    }
    getUserWxCompany();
  }, [props?.userView]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const wxCompany = props?.userView?.user_wx_comapny?.wx_company;
    if (wxCompany === "Any") {
      setWxCom("");
    } else {
      setWxCom(props?.userView?.user_wx_comapny?._id);
    }
    global.config.activityLog(window.location.href, 'Bank', `Entered into add bank page`);
    setCurrency(Currencies.sourceCurrencies[0].targetCurrencies);
  }, [props?.userView]);

  async function fetchBankRequirments(currency) {
    setErrors([]); // Clear any previous errors
    try {
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `https://api.sandbox.transferwise.tech/v1/account-requirements?source=USD&target=${currency}&sourceAmount=1000`,
      };

      // Use await directly instead of .then/.catch
      const response = await axios.request(config);
      setReq(response.data); // Update state with the fetched data
    } catch (error) {
      console.error("Error fetching bank requirements:", error);

      // Handle specific error cases
      if (error.response?.data?.status === "deleted") {
        // Clear user data and redirect if the user is deleted
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());

        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        navigate("/");
        return; // Exit the function early
      }

      // Show a generic error message for other errors
      toast.error('Something went wrong while fetching bank details!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function fetchRequirments(getType, getReq) {
    setErrors([]);
    getReq.map((item) => {
      if (item.type === getType) {
        setFields(item.fields);
      }
    });
    return;
  }

  async function submitBank(event) {
    event.preventDefault();
    try {
      var a = document.forms["bankForm"].getElementsByTagName("input");
      var b = document.forms["bankForm"].getElementsByTagName("select");
      var c = document.forms["bankForm"].getElementsByTagName("radio");
      var inputs = {};

      for (let [key, value] of Object.entries(a)) {
        var fieldName = value.name;
        inputs[fieldName] = event.target[fieldName].value;
      }

      inputs['email'] = props.userEmail;

      for (let [key, value] of Object.entries(b)) {
        var fieldName = value.name;
        inputs[fieldName] = event.target[fieldName].value;
      }

      for (let [key, value] of Object.entries(c)) {
        var fieldName = value.name;
        inputs[fieldName] = event.target[fieldName].value;
      }

      inputs['wxCompany'] = wxCom;

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: '/api/wise/add-new-bank',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: inputs
      };
      setIsLoading(true);
      axios.request(config)
        .then(async (response) => {

          if (response.data === true) {
            toast.success('New bank account added successfully!', {
              position: 'bottom-right',
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            global.config.activityLog(
              window.location.href,
              "User Bank",
              `A new bank account for ${props && props.userName}'s has been successfully added.`
            );
            setSelectedCurrency(null)

            setReq([]);
            setType(null);
            setFields([]);
            setErrors([]);
            await dispatch(setBankFetchUpdate());
            props.closeCreateModal();
          } else {
            setErrors(response.data.message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          global.config.slackMessage(error.toString());
        });
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error('Something went worng adding the bank!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "User Bank",
        `Something went worng while adding the bank for ${props && props.userName}`
      );
    } finally {

    }
  }
  const [selectedCountry, setSelectedCountry] = useState('');

  // Error popup modal state
  const [errorPopup, setErrorPopup] = useState({ show: false, messages: [] });

  // Helper to show error popup (accepts multiple messages)
  const showErrorPopup = (messages) => {
    setErrorPopup({ show: true, messages });
  };

  // Helper to close error modal
  const closeErrorModal = () => {
    setErrorPopup({ show: false, messages: [] });
    setTimeout(() => {
      document.body.classList.remove("ReactModal__Body--open");
    }, 100);
  };

  // Comprehensive list of US states
  const usStates = [
    { key: 'AL', name: 'Alabama' },
    { key: 'AK', name: 'Alaska' },
    { key: 'AZ', name: 'Arizona' },
    { key: 'AR', name: 'Arkansas' },
    { key: 'CA', name: 'California' },
    { key: 'CO', name: 'Colorado' },
    { key: 'CT', name: 'Connecticut' },
    { key: 'DE', name: 'Delaware' },
    { key: 'FL', name: 'Florida' },
    { key: 'GA', name: 'Georgia' },
    { key: 'HI', name: 'Hawaii' },
    { key: 'ID', name: 'Idaho' },
    { key: 'IL', name: 'Illinois' },
    { key: 'IN', name: 'Indiana' },
    { key: 'IA', name: 'Iowa' },
    { key: 'KS', name: 'Kansas' },
    { key: 'KY', name: 'Kentucky' },
    { key: 'LA', name: 'Louisiana' },
    { key: 'ME', name: 'Maine' },
    { key: 'MD', name: 'Maryland' },
    { key: 'MA', name: 'Massachusetts' },
    { key: 'MI', name: 'Michigan' },
    { key: 'MN', name: 'Minnesota' },
    { key: 'MS', name: 'Mississippi' },
    { key: 'MO', name: 'Missouri' },
    { key: 'MT', name: 'Montana' },
    { key: 'NE', name: 'Nebraska' },
    { key: 'NV', name: 'Nevada' },
    { key: 'NH', name: 'New Hampshire' },
    { key: 'NJ', name: 'New Jersey' },
    { key: 'NM', name: 'New Mexico' },
    { key: 'NY', name: 'New York' },
    { key: 'NC', name: 'North Carolina' },
    { key: 'ND', name: 'North Dakota' },
    { key: 'OH', name: 'Ohio' },
    { key: 'OK', name: 'Oklahoma' },
    { key: 'OR', name: 'Oregon' },
    { key: 'PA', name: 'Pennsylvania' },
    { key: 'RI', name: 'Rhode Island' },
    { key: 'SC', name: 'South Carolina' },
    { key: 'SD', name: 'South Dakota' },
    { key: 'TN', name: 'Tennessee' },
    { key: 'TX', name: 'Texas' },
    { key: 'UT', name: 'Utah' },
    { key: 'VT', name: 'Vermont' },
    { key: 'VA', name: 'Virginia' },
    { key: 'WA', name: 'Washington' },
    { key: 'WV', name: 'West Virginia' },
    { key: 'WI', name: 'Wisconsin' },
    { key: 'WY', name: 'Wyoming' },
  ];

  // Error modal popup for errors
  useEffect(() => {
    if (errors.length > 0) {
      const messages = errors.map((item) => item.message);
      showErrorPopup(messages);
    }
  }, [errors]);

  return (
    <div className='bank-add-form'>
      <form autoComplete="off" name="bankForm" onSubmit={submitBank}>
        {wxCompany === "Any" && (
          <div className="form-field-client">
            <label htmlFor="Type" className="form-label">
              Company *
            </label>
            <select
              id="wxCom"
              name="wxCom"
              className="form-select"
              value={wxCom}
              onChange={(e) => {
                setWxCom(e.target.value);
              }}
              required
            >
              <option value="">Select Company</option>
              {userWiseProfile?.length > 0 && userWiseProfile.map((item) => {
                return (<option value={item._id}>{item.wx_company}</option>);
              })}
            </select>
          </div>
        )}

        <div>
          <div className="form-field-client">
            <label htmlFor="accountHolderName" className="form-label">
              Account Holder Name (First name  Last name) *
            </label>
            <input
              id="accountHolderName"
              name="accountHolderName"
              className="form-input"
              autoComplete="off"
              placeholder="First name  Last name"
              value={accountHolderName}
              onChange={(e) => {
                if (!/\d|\./.test(e.target.value)) {
                  setAccountHolderName(e.target.value);
                }
              }}
              required
            />
          </div>
          <div className="form-field-client">
            <label htmlFor="countryCode" className="form-label">
              Currency Code *
            </label>
            <select
              id="country"
              name="currency"
              className="form-select"
              autoComplete="off"
              value={selectedCurrency}
              onChange={async (e) => {
                setSelectedCurrency(e.target.value);

                setType([]);
                setReq([]);
                setFields([]);
                await fetchBankRequirments(e.target.value);
              }}
              required
            >
              <option value="">Select Currency</option>
              {currency.length > 0 ? (
                <>
                  {currency.map((item, index) => (
                    <option key={Math.random().toString().replace("0.", "")} value={item.currencyCode}>{item.currencyCode}</option>
                  ))}
                </>
              ) : (
                <option>---</option>
              )}
            </select>

          </div>
          <div className="form-field-client">
            <label htmlFor="Type" className="form-label">
              Type
            </label>
            <select
              id="type"
              name="type"
              className="form-select"
              autoComplete="off"
              value={type}
              onChange={async (e) => {
                setType(e.target.value);
                await fetchRequirments(e.target.value, req);
                return;
              }}
              required
            >
              <option value="">Select Type of Account</option>
              {req.length > 0 ? (
                <>
                  {req.map((item, index) =>
                  (
                    <option value={item.type} key={Math.random().toString().replace("0.", "")}>{item.title}</option>
                  )
                  )}
                </>
              ) : (
                <option>--</option>
              )}
            </select>

          </div>
          {console.log("fields", fields)}
          {fields.length > 0 ? (
            <>
              <>
                {fields.length > 0 && (
                  <>
                    {fields.map((fieldItem) => (
                      <div key={fieldItem.group[0].key}>
                        <div className="form-field-client">
                          <label className="form-label" htmlFor={fieldItem.group[0].key.replaceAll('.', '_')}>
                            {fieldItem.name} {fieldItem.group[0].required && '*'}
                          </label>
                          <>
                            {fieldItem.group[0].type === 'select' && (
                              <select
                                autoComplete="off"
                                required={fieldItem.group[0].required}
                                name={fieldItem.group[0].key.replaceAll('.', '_')}
                                className="form-select"
                                onChange={(e) => {
                                  if (fieldItem.group[0].key === 'address.country') {
                                    setSelectedCountry(e.target.value);
                                  }
                                }}
                              >
                                <option value="">{fieldItem.group[0].example || 'Select an option'}</option>
                                {fieldItem.group[0].valuesAllowed.map((item) => (
                                  <option key={item.key} value={item.key}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            )}

                            {fieldItem.group[0].type === 'text' && (
                              <input
                                autoComplete="off"
                                required={fieldItem.group[0].required}
                                name={fieldItem.group[0].key.replaceAll('.', '_')}
                                className="form-input"
                                type="text"
                                placeholder={fieldItem.group[0].name}
                              />
                            )}

                            {fieldItem.group[0].type === 'date' && (
                              <input
                                autoComplete="off"
                                required={fieldItem.group[0].required}
                                name={fieldItem.group[0].key.replaceAll('.', '_')}
                                className="form-input"
                                type="date"
                                placeholder={fieldItem.group[0].name}
                              />
                            )}

                            {fieldItem.group[0].type === 'radio' && (
                              <div className="form-field-client-radio-outer">
                                {fieldItem.group[0].valuesAllowed.map((item) => (
                                  <div key={item.key} className="form-field-client">
                                    <label className="form-label">{item.name}</label>
                                    <input
                                      autoComplete="off"
                                      required={fieldItem.group[0].required}
                                      type="radio"
                                      name={fieldItem.group[0].key.replaceAll('.', '_')}
                                      value={item.key}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        </div>
                        {fieldItem.group[0].key === 'address.country' && selectedCountry === 'US' && (
                          <div className="form-field-client">
                            <label className="form-label" htmlFor="state">
                              State *
                            </label>
                            <select
                              autoComplete="off"
                              required
                              name="address_state"
                              className="form-select"
                            >
                              <option value="">Select a state</option>
                              {usStates.map((state) => (
                                <option key={state.key} value={state.key}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </>
            </>
          ) : (
            <p className='hide-this'></p>
          )}
          <button type="submit" disabled={isLoading || (wxCom && wxCom === "Any") || (wxCom && wxCom === "") || !wxCom}>
            {isLoading ?
              <div className="outter-load-table">
                <ThreeDots
                  height="18"
                  width="20"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div> : "Submit"}
          </button>
        </div>
      </form>
      {/* Error Modal */}
      {errorPopup.show && (
        <Modal
          className="delete-modal"
          isOpen={errorPopup.show}
          onRequestClose={closeErrorModal}
          contentLabel="Error Message"
          style={{
            content: {
              height: "30%",
              width: "28%",
              position: "fixed",
              top: "36%",
              left: "50%",
              transform: "translate(-19.75%, 0%)",
              parent: document.querySelector(".admin-outer.time.tracker"),
            },
          }}
        >
          <div className="delete-modal-content" style={{ textAlign: "center" }}>
            <h2 style={{ color: "#e74c3c", marginBottom: "16px" }}>Error</h2>
            <ul style={{ listStyleType: "decimal", paddingLeft: "20px", textAlign: "left", marginBottom: "24px" }}>
              {errorPopup.messages.map((msg, i) => (
                <li key={i} style={{ marginBottom: "10px", fontSize: "16px", lineHeight: "1.6", color: "#333" }}>{msg}</li>
              ))}
            </ul>
            <div className="delete-modal-buttons">
              <button
                onClick={closeErrorModal}
                style={{
                  backgroundColor: "#4F46E5",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 18px",
                  fontWeight: "500",
                  fontSize: "14px",
                  cursor: "pointer"
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

export default NewBank;